import {
  PartnerSectionsPage,
  ProductSectionsPage,
  CatalogSectionListPage,
  CatalogSectionEditPage,
  CatalogSectionCreatePage,
} from './imports';

export const catalogSectionsRoutes = [
  {
    path: 'catalog-sections',
    children: [
      { element: <CatalogSectionListPage />, index: true },
      { path: 'list', element: <CatalogSectionListPage /> },
      { path: 'new', element: <CatalogSectionCreatePage /> },
      { path: ':id/edit', element: <CatalogSectionEditPage /> },
      { path: 'partners', element: <PartnerSectionsPage /> },
      { path: 'products', element: <ProductSectionsPage /> },
    ],
  },
];
